/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Copy_Event_Text_FailedInputs */

const en_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event text copy failed`)
};

const fr_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la copie du texte de l'événement`)
};

const de_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren des Ereignistextes fehlgeschlagen`)
};

const it_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia del testo dell'evento non riuscita`)
};

const ru_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось скопировать текст события`)
};

const es_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al copiar el texto del evento`)
};

const zh_cn2_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件文本复制失败`)
};

const ja_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストのコピーに失敗しました`)
};

const hi_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट कॉपी विफल`)
};

const pt_pt2_copy_event_text_failed = /** @type {(inputs: Copy_Event_Text_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao copiar texto do evento`)
};

/**
* | output |
* | --- |
* | "Event text copy failed" |
*
* @param {Copy_Event_Text_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const copy_event_text_failed = /** @type {((inputs?: Copy_Event_Text_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Copy_Event_Text_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_copy_event_text_failed(inputs)
	if (locale === "de") return de_copy_event_text_failed(inputs)
	if (locale === "it") return it_copy_event_text_failed(inputs)
	if (locale === "ru") return ru_copy_event_text_failed(inputs)
	if (locale === "es") return es_copy_event_text_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_copy_event_text_failed(inputs)
	if (locale === "ja") return ja_copy_event_text_failed(inputs)
	if (locale === "hi") return hi_copy_event_text_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_copy_event_text_failed(inputs)
	return en_copy_event_text_failed(inputs)
});